import { render } from "./lrbTable2.vue?vue&type=template&id=a73db128&scoped=true"
import script from "./lrbTable2.vue?vue&type=script&lang=js"
export * from "./lrbTable2.vue?vue&type=script&lang=js"

import "./lrbTable2.vue?vue&type=style&index=0&id=a73db128&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a73db128"]])

export default __exports__